module.exports = __webpack_public_path__ + "img/dmt-03.prt.45e6b814.jpg";